import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { FolderDocument } from 'src/app/models/server/folder-document';
import { Sms } from 'src/app/models/server/sms';
import { ConnectedUsersStateService } from '../state/connected-users-state.service';
import { ViewsStateService } from '../state/views-state.service';
import { ServiceBase } from './service-base';

@Injectable({
    providedIn: 'root',
})
export class SmsService extends ServiceBase {
    constructor(
        private http: HttpClient,
        public override connectedUserStateService: ConnectedUsersStateService,
        public viewsStateService: ViewsStateService
    ) {
        super(connectedUserStateService);
    }

    /**
     * Envoi un SMS.
     * @param viewId Id de la vue à laquelle appartient le dossier.
     * @param folderId Id du dossier.
     * @param sms : Instance du SMS.
     * @returns : L'instance du SMS créé.
     */
    public sendSms(viewId: number, folderId: string, sms: Sms): Observable<FolderDocument> {
        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
        };

        return this.http.post<FolderDocument>(this.baseUrl + `/api/organizations/${this.organizationId}/views/${viewId}/folders/${folderId}/sms`, sms, httpOptions).pipe(
            map((x) => {
                return FolderDocument.fromJson(x);
            })
        );
    }
}
